import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";
import { Compare } from "../common/slider";
import { useState } from "react";

function Offer4Ogrodzenia() {
  const [activeTransform, setActiveTransform] = useState(1);

  const handleChooseTransform = (index: number) => {
    setActiveTransform(index);
  };
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/Ogrodzenie-drewniane-montaz-ogrodzen-z-desek-Duzy.jpeg"
          alt="Montaż ogrodzenia drewnianego - realizacja Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Montaż ogrodzeń panelowych i siatkowych Gdańsk, Gdynia, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Trwałe ogrodzenia działek budowlanych i posesji na Pomorzu
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Solidne ogrodzenie to bezpieczeństwo Twojej działki podczas budowy oraz wykończenie wokół nowego domu. Oferujemy profesjonalny montaż ogrodzeń panelowych, siatek ogrodzeniowych oraz podmurówek na terenie Gdańska, Gdyni, Wejherowa, Kartuz i na Kaszubach. Nasze prace montażowe świetnie uzupełniają wcześniejsze <a href="/oczyszczanie-terenu/czyszczenie-dzialek" className="underline hover:opacity-80">oczyszczanie działki</a> oraz <a href="/oczyszczanie-terenu/niewelacja-terenu" className="underline hover:opacity-80">równanie terenu</a>.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Przygotowanie terenu i niwelacja pod ogrodzenie
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Montaż ogrodzeń na działkach prywatnych i inwestycyjnych
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Ogrodzenie działki przed budową i sprzedażą
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Zalety ogrodzeń panelowych
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czy warto zamontować ogrodzenie drewniane?
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Usługi montażu ogrodzenia krok po kroku
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Przygotowanie terenu i niwelacja pod ogrodzenie</h2>
          <p>
            Chcesz pozbyć się nieproszonych gości ze swojej posesji? Zainwestuj
            w montaż ogrodzenia. Zapewni Ci ono spokój i bezpieczeństwo na
            Twojej działce. Wykonujemy wszystkie niezbędne prace prowadzące do
            powstania solidnego ogrodzenia.
          </p>
          <h2 id="2">Montaż ogrodzeń na działkach prywatnych i inwestycyjnych</h2>
          <p>
            Samodzielny <strong>montaż ogrodzenia</strong> wymaga sporego
            nakładu pracy. Do takich prac przydaje się doświadczenie w branży
            budowlanej, siła fizyczna oraz odpowiedni sprzęt. Jednak nie musisz
            męczyć się z tym zadaniem.
          </p>
          <p>
            Wystarczy zadzwonić do nas.{" "}
            <strong>Wykonamy dla Ciebie ogrodzenie od A do Z</strong>. Nasza
            usługa obejmuje wykonanie podmurówki, wstawienie słupków
            ogrodzeniowych oraz montaż ogrodzenia.
          </p>
          <p>
            Przygotujemy też teren pod ogrodzenie, zaczynając od usunięcia
            zbędnych krzewów, pni, a nawet całych drzew, przez niwalecję terenu,
            aż do nasadzeń zieleni przy gotowym płocie.
          </p>
          <p>
            Nie musisz obawiać się o rezultaty tych prac. Nasi fachowcy mają
            {" "}<strong>wieloletnie doświadczenie w montażu ogrodzeń</strong>. Nie
            straszny im żaden teren. Otrzymasz bezpłatną wycenę i kompleksową
            obsługę swojego zlecenia.
          </p>
          <h2 id="3">Ogrodzenie działki przed budową i sprzedażą</h2>
          <p>
            Na początku musisz zdecydować się na rodzaj ogrodzenia, które ma
            stanąć na Twojej posesji. Najczęściej można spotkać następujące
            rodzaje ogrodzeń:
          </p>
          <ul>
            <li>• ażurowe,</li>
            <li>• lamelowe,</li>
            <li>• panelowe,</li>
            <li>• gabionowe</li>
            <li>• sztachetowe,</li>
            <li>• z siatki ogrodzeniowej.</li>
          </ul>
          <p>
            <strong>Ogrodzenia gabionowe</strong> to stalowe kosze, które
            wypełnia się ozdobnym kamieniem lub szkłem turkusowym. Ściany
            wewnątrz tego ogrodzenia połączone są metolowymi wspornikami, które
            odpowiadają za to, że kosz gabionowy zachowa swój kształt po
            wypełnieniu kamieniami. W przypadku ogrodzeń stalowych wykonujemy
            też podstawowe projekty takich płotów.
          </p>
          <p>
            <strong>Ogrodzenia panelowe</strong> składają się z gotowych przęseł
            i słupków. Panele ogrodzeniowe występują w różnych kolorach. Przy
            wyborze takiego ogrodzenia można również montować furtki i bramy w
            takim samym stylu. Zaletą ogrodzenia panelowego jest duża odporność
            na uszkodzenia mechaniczne, pod warunkiem, że wykonane je z dość
            grubego drutu.
          </p>
          <p>
            <strong>Ogrodzenia z siatki</strong> to jedne z najtańszych rodzajów
            ogrodzenia. W przypadku takiego ogrodzenia na ostateczny efekt
            wizualny ogromny wpływ ma prawidłowy montaż. Złe naciągnięcie siatki
            spowoduje odkształcenie oczek siatki, przez co płot nie będzie
            wyglądał zbyt estetycznie. Dlatego nawet w wypadku takiego
            ogrodzenia lepiej zlecić jego wykonanie fachowcom.
          </p>
          <p>
            <strong>Zleć nam montaż Twojego ogrodzenia</strong>. Wykonamy je bez
            względu na wybrany przez Ciebie rodzaj płotu. Krok po kroku
            przygotujemy teren do montażu ogrodzenia.
          </p>
          <p>
            Oferujemy również usługi związąne z zakładaniem ogrodów. Dlatego
            warto skorzystać z naszej kompleksowej oferty, zwłaszcza gdy chcesz
            zadbać o teren wokół swojego domu, upiększyć działkę czy
            uporządkować posesję.
          </p>
          <p>
            Nie musisz szukać różnych wykonawców. Wszystko zrobi nasza ekipa –
            od usuwania zbędnych drzew i krzewów, przez wyrywanie pni, aż po
            montaż ogrodzenia i założenie ogrodu czy trawnika.
          </p>
          <h2 id="4">Zalety ogrodzeń panelowych</h2>
          <p>
            Panele ogrodzeniowe metalowe świetnie pasują do nowoczesnej
            architektury, ale sprawdzą się też przy architekturze klasycznej.
            <strong>Płoty panelowe</strong> są lekkie i mają dużą przejrzystość,
            przez co nie zasłaniają widoku całej działki.
          </p>
          <p>
            Takie ogrodzenie można zamontować w połączeniu z podmurówką czy
            nawet elementami gabionowymi, dzięki czemu ogrodzenie zyska zupełnie
            inny wygląd. Ich zaletą jest również szeroka gama kolorystyczna.
            Każdy znajdzie tu coś dla siebie.
          </p>
          <p>
            Ogrodzenie panelowe można obsadzić roślinami pnącymi lub tujami,
            które zapewnią odgrodzenie od sąsiednich działek. Jeśli zdecydujesz
            się na takie rozwiązanie, to wykonamy dla Ciebie wszystkie potrzebne
            nasadzenia zarówno roślin zielonych, jak i iglaków.
          </p>
          <p>
            Panele ogrodzeniowe są dość odporne na korozję, pod warunkiem, że
            zostały ocynkowane ogniowo lub galwanicznie, a następnie pomalowane
            proszkowo. Z tego powodu są materiałem znacznie trwalszym od zwykłej
            siatki ogrodzeniowej.
          </p>
          <h2 id="5">Czy warto zamontować ogrodzenie drewniane?</h2>
          <p>
            Jeśli szukasz ogrodzenia, które będzie w zgodzie z naturą, to oprócz
            żywopłotów warto sprawdzić możliwości jakie dają{" "}
            <strong>ogrodzenia drewniane</strong>. Na rynku występują różne
            rodzaje ogrodzeń drewnianych, dlatego bez problemu możesz znaleźć
            coś, co będzie dla Ciebie najlepsze. W tej grupie znajdują się
            ogrodzenia ażurowe, lamelowe i sztachetowe.
          </p>
          <p>
            <strong>Ogrodzenia ażurowe</strong> charakteryzują się dużymi
            prześwitami. Można je wykorzystać jako podpory dla roślin pnących.
            Mogą występować też jako połączenie ogrodzenia litego z elementami
            ażurowymi, a także jako ogrodzenia metalowe, a nawet betonowe.
          </p>
          <p>
            <strong>Ogrodzenia lamelowe</strong> to bardzo popularny typ
            ogrodzeń. Składają się one z ramy oraz listew wypełniających w
            postaci długich i wąskich deseczek. Chronią przed podmuchami wiatru
            i wścibskim okiem sąsiadów. Mogą być też wykorzystane jako zasłona
            do starego płotu z siatki ogrodzeniowej.
          </p>
          <p>
            <strong>Ogrodzenia sztachetowe</strong> to klasyczny, najstarszy
            stosowany rodzaj ogrodzeń. Składają się z poziomych żerdzi i pionowo
            ustawionych desek (sztachet). To umożliwia stworzenie zarówno
            niskiego, jak i wysokiego płotu.
          </p>
          <p>
            Jednak musisz pamiętać, że drewno jest materiałem mniej trwałym niż
            stal czy beton. Wymaga ono częstszej konserwacji i malowania. Z tego
            powodu ciekawą alternatywą są{" "}
            <strong>ogrodzenia sztachetowe metalowe</strong>. Są one trwalsze od
            drewnianych, bo nie wymagają impregnacji czy malowania. Jednak
            przekłada się to na wyższą cenę.
          </p>
          <h2 id="6">Usługi montażu ogrodzenia krok po kroku</h2>
          <p>
            Przygotujemy dla Ciebie profesjonalną wycenę. Wystarczy, że
            wypełnisz formularz kontaktowy. Podaj nam ile potrzebujesz metrów
            bieżących, a także wysokość i rodzaj planowanego ogrodzenia.
          </p>
          <p>
            Jeśli konieczne jest zdemontowanie obecnego ogrodzenia, to
            poinformuj o tym w swoim zgłoszeniu. Nasi fachowcy sprawią, że w
            krótkim czasie na Twojej posesji powstanie nowy płot.
          </p>
          <p>
            W razie wątpliwości, na które ogrodzenie się zdecydować, możemy
            doradzić i na miejscu ustalić wszystkie szczegóły.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="px-6 pb-6 lg:px-24 lg:pb-12 flex flex-col gap-6">
        <div className="w-full bg-gray-100 rounded-xl p-6 flex flex-col gap-6">
          <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between">
            <div className="flex flex-col items-start justify-start gap-2">
              <h2 className="uppercase color-yellow text-xl">Transformacje</h2>
              <h3 className="text-3xl lg:text-5xl color-green">
                Zobacz jak odmieniamy{" "}
                <span className="color-yellow">ogrody</span>
              </h3>
            </div>
            <a href="/kontakt">
              <button className="button-green">Bezpłatna wycena</button>
            </a>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            <div
              id="chooseTransform1"
              onClick={() => handleChooseTransform(1)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-1-koniec-1.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 1 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform2"
              onClick={() => handleChooseTransform(2)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-2-koniec-1.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 2 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform3"
              onClick={() => handleChooseTransform(3)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-3-koniec-1.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 3 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform4"
              onClick={() => handleChooseTransform(4)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-4-koniec-1.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 4 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform5"
              onClick={() => handleChooseTransform(5)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-5-koniec.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 5 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform6"
              onClick={() => handleChooseTransform(6)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-6-koniec.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 6 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform7"
              onClick={() => handleChooseTransform(7)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-7-koniec.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 7 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform8"
              onClick={() => handleChooseTransform(8)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-8-koniec.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 8 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform9"
              onClick={() => handleChooseTransform(9)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-9-koniec.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 9 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform10"
              onClick={() => handleChooseTransform(10)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-10koniec.jpg"
                alt="Montaż ogrodzenia - realizacja Drzewus nr 10 - efekt końcowy"
              />
            </div>
          </div>
          <div className="">
            <div
              className={`w-full ${activeTransform === 1 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-1-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-1-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 2 ? "block" : "hidden"}`}
              id="transform2"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-2-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-2-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 3 ? "block" : "hidden"}`}
              id="transform3"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-3-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-3-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 4 ? "block" : "hidden"}`}
              id="transform4"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-4-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-4-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 5 ? "block" : "hidden"}`}
              id="transform5"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-5-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-5-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 6 ? "block" : "hidden"}`}
              id="transform6"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-6-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-6-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 7 ? "block" : "hidden"}`}
              id="transform7"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-7-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-7-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 8 ? "block" : "hidden"}`}
              id="transform8"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-8-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-8-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 9 ? "block" : "hidden"}`}
              id="transform9"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-9-start.jpg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-9-koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${
                activeTransform === 10 ? "block" : "hidden"
              }`}
              id="transform10"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-10-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ogrodzenia-10koniec.jpg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[800px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer4Ogrodzenia;